namespace GeniuzPOS.InitialData {
    export interface PsRefundReasonForm {
        RefundFg: Serenity.RadioButtonEditor;
        RefundId: Serenity.IntegerEditor;
        RefundReason: Serenity.StringEditor;
        PurposeCode: Serenity.LookupEditor;
        TaxRefundReasonId: Serenity.LookupEditor;
        Remark: Serenity.StringEditor;
    }

    export class PsRefundReasonForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsRefundReason';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsRefundReasonForm.init)  {
                PsRefundReasonForm.init = true;

                var s = Serenity;
                var w0 = s.RadioButtonEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;

                Q.initFormType(PsRefundReasonForm, [
                    'RefundFg', w0,
                    'RefundId', w1,
                    'RefundReason', w2,
                    'PurposeCode', w3,
                    'TaxRefundReasonId', w3,
                    'Remark', w2
                ]);
            }
        }
    }
}
